<template> 
  <div :style="{ zIndex: new Date().getTime()-1741763154594 }" class="qiandao" v-if="show">
    <div class="box">
      <div class="close">
        <img src="../../assets/lives/qd_cancel.png" alt="" @click="close" />
      </div>
      <div class="title">签 到</div>
      <!-- bottom -->
      <div class="bottom">
        <div class="top">
          <img class="tagIcon" src="../../assets/lives/wqd.png" alt="" />
          <!-- <img class="tagIcon" src="../../assets/lives/yqd.png" alt=""> -->
        </div>
        <p>倒计时</p>
        <p class="djs">{{ times }}</p>
        <button :class="['singBtn', singDisabled ? 'singBtnIng' : '']" @click="signAdd">点击签到</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sign",

  data() {
    return {
      show: false,
      qd_type: 0,
      messageFalg: true,
      time_countdown: null,
      times: `00 : 00 : 00`,
      timer: null,
      singStartTime: 0,
      singLang: 5,
      singDisabled: false,
      stat: {
        statId: 0,
        timeOut: 0,
        sendTime: 0,

      },
    };
  },

  methods: {
    countdown(targetTimestamp) {
      let _this = this;
      this.timer = setInterval(() => {
        const now = Date.now();
        const distance = targetTimestamp - now;
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        // 显示倒计时
        _this.times = `${hours < 10 ? "0" + hours : hours} : ${minutes < 10 ? "0" + minutes : minutes
          } : ${seconds < 10 ? "0" + seconds : seconds}`;
        // 如果倒计时结束，清除定时器
        if (distance < 0) {
          _this.times = `00 : 00 : 00`;
          _this.close();
        }
      }, 1000); // 每秒更新一次
    },
    // 关闭
    close() {
      this.times = `00 : 00 : 00`;
      clearInterval(this.timer);
      this.show = false;
    },
    // 签到
    signAdd() {
      if (this.singDisabled) {
        return;
      }
      this.singDisabled = true
      let _this = this;
      this.$liveapi
        .signadd({
          customName: localStorage.getItem("user_name"),
          roomId: Number(sessionStorage.getItem("live_id")),
          statId: this.stat.statId,
        })
        .then((res) => {
          clearInterval(_this.timer);
          _this.singDisabled = false
          _this.times = `00 : 00 : 00`;
          _this.show = !_this.show;
          _this.$message({
            message: "签到成功",
            type: "success",
          });


        });
    },
    //显示模态框
    showSign(params) {
      let _this = this;
      this.stat.statId = params.statId;
      this.stat.timeOut = params.timeOut;
      this.stat.sendTime = params.sendTime;
      this.countdown(this.stat.timeOut);
      let singStart = setTimeout(() => {
        _this.show = true;
        clearTimeout(singStart);
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.qiandao {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.qiandao .box {
  width: 280px;
  height: 307px;
  background: #fdf0c6;
  background-color: #fdf0c6;
  border-radius: 8px;
  margin: 15% auto;
  position: relative;
}

.qiandao .box .close {
  text-align: right;
  padding: 10px 16px;
  padding-bottom: 0;
}

.qiandao .box .close img {
  width: 13px;
  height: 13px;
}

.bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 200px;
  background: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 10px 14px;
  box-sizing: border-box;
  display: flex;
  padding-top: 50px;
  flex-direction: column;
  justify-content: space-between;

  // justify-content: end;
}

.title {
  font-size: 16px;
  font-weight: bold;
  color: #343434;
  text-align: center;
}

.qd_ing {
  width: 110px;
  height: 126px;
  background: url(../../assets/lives/qd_ing.png);
  background-size: 100%;
  margin: 0px auto;
  color: #2e95f8;
  font-weight: bold;
  text-align: center;
  font-size: 14px;
  line-height: 190px;
}

.qd_ok {
  width: 110px;
  height: 126px;
  background: url(../../assets/lives/qd_ok.png);
  background-size: 100%;
  margin: 0px auto;
  color: #2e95f8;
  font-weight: bold;
  text-align: center;
  font-size: 14px;
  line-height: 190px;
}

.qd_tips {
  font-size: 12px;
  color: #999999;
  text-align: center;
  margin-top: 10px;
}

.singBtn {
  background: #ffa561;
  height: 42px;
  line-height: 42px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
  // crusor: pointer;
  border: 0;
  cursor: pointer !important;
}

.singBtnIng {
  background: #e8e8e8;
}

.djs {
  font-size: 25px;
  color: #e8341f;
  font-weight: bold;
}

.top {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 60px;
  text-align: center;
}

.tagIcon {
  width: 60px;
  height: 60px;
}
</style>
